/**
 * @generated SignedSource<<0e49c36f15def4299c79463c5aaf3182>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TryOnType = "BRACELET" | "EARRINGS" | "EYEWEAR" | "HEADWEAR" | "NECKLACE" | "NOT_SELECTED" | "SCARVES" | "SHOES" | "WATCHES";
export type ProductTryOnInput = {
  id: string;
  productCode?: string | null;
  productName?: string | null;
  settings: TryOnProviderBaseProductSettingsInput;
  typeID: TryOnType;
};
export type TryOnProviderBaseProductSettingsInput = {
  active?: boolean | null;
  pd?: boolean | null;
  tryOn?: boolean | null;
};
export type useSaveProductCreateOrUpdateVTOMutation$variables = {
  input: ProductTryOnInput;
};
export type useSaveProductCreateOrUpdateVTOMutation$data = {
  readonly updateOrCreateTryOnProduct: {
    readonly productTryOn: {
      readonly id: string;
    } | null;
  };
};
export type useSaveProductCreateOrUpdateVTOMutation = {
  response: useSaveProductCreateOrUpdateVTOMutation$data;
  variables: useSaveProductCreateOrUpdateVTOMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductTryOnOutput",
    "kind": "LinkedField",
    "name": "updateOrCreateTryOnProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTryOn",
        "kind": "LinkedField",
        "name": "productTryOn",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveProductCreateOrUpdateVTOMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSaveProductCreateOrUpdateVTOMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a162ea18085744faced0f11d724da3fa",
    "id": null,
    "metadata": {},
    "name": "useSaveProductCreateOrUpdateVTOMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveProductCreateOrUpdateVTOMutation(\n  $input: ProductTryOnInput!\n) {\n  updateOrCreateTryOnProduct(input: $input) {\n    productTryOn {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d9c495343d058856264c813be53c5e89";

export default node;
